import React from "react";
import ResultDisplayClass1 from "./results/ResultDisplayClass1";
import ResultDisplayClass2 from "./results/ResultDisplayClass2";
import ResultDisplayClass3 from "./results/ResultDisplayClass3";
import ResultDisplayClass4 from "./results/ResultDisplayClass4";
import ResultDisplayClass5 from "./results/ResultDisplayClass5";
import ResultBackButton from "./results/ResultBackButton.js";
import ResultDisplayExcluded from "./results/ResultDisplayExcluded";
import { appVersion } from "./config";

function checkIfStatusChange(res) {
   
    if (res.filter(r => (r.display_class === 1 || r.display_class === 2)).length > 1) {
         // have counts of parcels with display classes 1 and/or2 greater than 1
        if (res.filter(r => ((r.tax_classification === null||r.tax_classification === ''||r.bill === null||r.bill === 0))).length > 0) {
            // have at least one child with a null tax_classification or bill value
            return true
        } 
        else if (res.filter(r => (r.display_class === 1 || r.display_class === 2)).length !== 2){
            // more than two, class 1s and 2s 
            return true
        }
        else if (!((res.filter(r => (r.tax_classification === 'AD VALOREM').length === 1)) && (res.filter(r => (r.tax_classification.includes("NEZ")).length === 1)))) {
            // not with one having a classification = "AD VALOREM" and one whose classification contains the letters "NEZ"
            return true
        }
    }
    return false
}

function checkIfResidential(res) {
    if (res.some(r => (r.property_class === 401 || r.property_class === 407))) {
        return true
    } else if (res.some(r => (r.property_class === 402) && (r.display_class === 2))) {
        return true
    } else {
        return false
    }
}

export default function ResultDisplay(props) {
    const res = props.results;
    console.log(res)
    let searchedRes = res.filter(r => r.pnum === props.searchedParcel) //searchedParcel is actually the completed search term, will return [] if not a parcel
    let disp;

    if (searchedRes.length === 0) {
        searchedRes = [{ display_class: 0 }] // set to zero so no match on line 20
    }

    if ((appVersion === 'public') && (!checkIfResidential(res))) {
        disp=(
            <div className="bg-city-green-light border-t border-b border-city-green-dark/70 text-city-green-dark px-4 py-3">
            <p className="text-lg">
            This application only displays residential structures.
            </p>
            <p className="text-sm">
            Please reference the FAQ on <a className="underline" href='https://detroitmi.gov/departments/office-chief-financial-officer/land-value-tax-plan' target="_blank" rel="noreferrer">the website</a> for more information. If you have additional questions about your property, please contact <a className="underline" href='mailto:LandValueTax@detroitmi.gov'>LandValueTax@detroitmi.gov</a>.
            </p>
        </div>
        )
    }
    else if (res.some(r => r.display_class === 3)) {
        disp = <ResultDisplayClass3 res={res} setResults={props.setResults} address={props.address} setAddress={props.setAddress} />
    }
    else if (searchedRes[0].display_class === 4) {
        disp = <ResultDisplayClass4 res={res} setResults={props.setResults} address={props.address} setAddress={props.setAddress} />
    }
    else if (checkIfStatusChange(res)) {
        disp = <ResultDisplayExcluded res={res} setResults={props.setResults} address={props.address} setAddress={props.setAddress} />
    }
    else if (res.some(r => r.display_class === 1)) {
        if (res.some(r => r.display_class === 2)) {
            disp = <ResultDisplayClass2 res={res} setResults={props.setResults} address={props.address} setAddress={props.setAddress} />
        } else {
            disp = <ResultDisplayClass1 res={res} setResults={props.setResults} address={props.address} setAddress={props.setAddress} />
        }
    } else if (res.every(r => [4, 5].includes(r.display_class))) {
        if (res.every(r => r.display_class === 4)) {
            disp = <ResultDisplayClass4 res={res} setResults={props.setResults} address={props.address} setAddress={props.setAddress} />
        } else {
            disp = <ResultDisplayClass5 res={res} setResults={props.setResults} address={props.address} setAddress={props.setAddress} />
        }
    } else {
        disp = <ResultDisplayClass2 res={res} setResults={props.setResults} address={props.address} setAddress={props.setAddress} />
    }

    return (
        <div className='h-full w-full overflow-auto flex'>
            <div className="my-auto">
                <div className="font-bold text-xl">Estimate using 2023 Values</div>
                <div className="font-bold text-base mb-1">Actual change will be comparable</div>
                {disp}
                <ResultBackButton setResults={props.setResults} setAddress={props.setAddress} />
            </div>
        </div>
    )
}